<ng-container *ngFor="let organism of organisms"> <ndc-dynamic [ndcDynamicComponent]="organism.component" [ndcDynamicInputs]="organism?.inputs"></ndc-dynamic> </ng-container>
